import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getUserDeviceInfoUrl } from "../utils/urlHelper";

const userDeviceInfoApi = createApi({
  reducerPath: "userDeviceInfo",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_LOGIN_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    userDeviceInfo: builder.mutation({
      query: (body) => ({
        url: getUserDeviceInfoUrl(),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useUserDeviceInfoMutation,
} = userDeviceInfoApi;

export { userDeviceInfoApi };
